import { HStack, Box } from '@chakra-ui/react';
import FormField from '../../../components/fields/FormField';
import { translate } from '../../../i18n';
import { GUEST_PHONE_COUNTRIES } from '../../court-details/utils/guest-player';
import { CoachContactDraft, coachContactErrors } from '../utils/coach-contact';

type Props = {
    value: CoachContactDraft;
    onChange: (next: CoachContactDraft) => void;
    isDisabled?: boolean;
};

/**
 * Phone + "show on the public profile" switch + booking-notification email.
 * Rendered for organization admins only: the notification email is theirs to
 * set (D2), and the full read behind an existing value is admin-only (D1).
 */
export default function CoachContactFields({ value, onChange, isDisabled }: Props) {
    const errors = coachContactErrors(value);
    const set = (patch: Partial<CoachContactDraft>) => onChange({ ...value, ...patch });
    return (
        <>
            <HStack spacing={3} align="start">
                <Box minW="170px">
                    <FormField
                        type="select"
                        label={translate('coachs.phone_calling_code')}
                        value={value.callingCode}
                        options={GUEST_PHONE_COUNTRIES.map((country) => ({
                            value: country.callingCode,
                            label: country.label,
                        }))}
                        onChange={(callingCode) => set({ callingCode })}
                        isDisabled={isDisabled}
                    />
                </Box>
                <FormField
                    type="tel"
                    label={translate('coachs.phone')}
                    placeholder="06 12 34 56 78"
                    value={value.phone}
                    onChange={(phone) => set({ phone })}
                    helperText={translate('coachs.phone_helper')}
                    error={errors.phone ? translate('coachs.phone_invalid') : undefined}
                    isDisabled={isDisabled}
                />
            </HStack>
            <FormField
                type="switch"
                label={translate('coachs.phone_public')}
                isChecked={value.isPhonePublic}
                onChange={(isPhonePublic) => set({ isPhonePublic })}
                helperText={translate('coachs.phone_public_helper')}
                isDisabled={isDisabled}
            />
            <FormField
                type="email"
                label={translate('coachs.notification_email')}
                value={value.notificationEmail}
                onChange={(notificationEmail) => set({ notificationEmail })}
                helperText={translate('coachs.notification_email_helper')}
                error={errors.notificationEmail ? translate('coachs.notification_email_invalid') : undefined}
                isDisabled={isDisabled}
            />
        </>
    );
}
